
export enum ProductType {
    Course = 'Course',
    Accommodation = 'Accommodation',
    AddOn = 'AddOn',
    Transfer = 'Transfer',
    Package = 'Package'
}

export function getProductTypeDisplayName(productType: ProductType) {
    switch (productType) {
        case ProductType.AddOn:
            return 'Add-on';
        default:
            return productType.toString();
    }
}

export enum CourseLanguage {
    English,
    French
}

export type ProductCommonFields = {
    code: string
    name: string
    active?: boolean
}

export type Course = ProductCommonFields & {
    type: ProductType.Course 
}

export enum AccommodationType {
    Residence,
    Homestay
}

export type Accommodation = ProductCommonFields & {
    type: ProductType.Accommodation
    accommodationType?: AccommodationType
}

export type AddOn = ProductCommonFields & {
    type: ProductType.AddOn
}

export enum TransferDirection {
    Arrival,
    Departure
}

export type Transfer = ProductCommonFields & {
    type: ProductType.Transfer
}

export type Package = ProductCommonFields & {
    type: ProductType.Package
}

export type Product = 
    Course
    | Accommodation
    | AddOn
    | Transfer
    | Package